/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/control-has-associated-label */
import {
    currentLeftMenuVar,
    getUserInfoVar,
    leftNavigationItemsVar, moduleIdVar, showCrossReportConfigVar, showDataReconMenusVar, showReportMenuVar,
} from 'Apollo/config';
import React, { useEffect, useState } from 'react';
import { GET_PENDING_INVIATION_COUNT, GET_REGISTRATION_INTAKE_LIST } from 'Apollo/Queries';
import { useMutation, useQuery, useReactiveVar } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { SEND_BULK_INVITATIONS } from 'Apollo/Mutations';
import { ModuleEnum } from 'constants';
import { columnsConfig, listItems } from './utils';
import Intake from '../components/Intake';

export default function IntakeContainer() {
    const history = useHistory();
    const [tableData, setTableData] = useState([]);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [filterString, setFilterString] = useState('');
    const [active, setActive] = useState(false);
    const [inactive, setInactive] = useState(false);
    const [moduleMap, setModuleMap] = useState({});

    const userInfo = useReactiveVar(getUserInfoVar);

    const { data: registrationIntakeData, refetch: refetchIntakeList } = useQuery(GET_REGISTRATION_INTAKE_LIST);

    /** Send invitation */
    const [sendBulkInvitations] = useMutation(SEND_BULK_INVITATIONS);

    const handleSendInvitationsToAll = async () => {
        try {
            const res = await sendBulkInvitations({
                variables: {
                    input: {
                        sendToAll: true,
                        email: '',
                        requestingUserEmail: userInfo?.getUser?.email,
                        organizationId: userInfo?.getUser?.iamTenant?.iamOrganizationId,
                        tenantId: userInfo?.getUser?.iamTenant?.tenantId,
                    },
                },
            });
            if (res.data?.sendBulkInvitations) {
                await refetchIntakeList();
                setSuccessMsg('Invitations sent successfully!');
                setShowSuccessAlert(true);
                setTimeout(() => setShowSuccessAlert(false), 3000);
            }
        } catch (err) {
            setErrorMsg('Invitations sending failed!');
            setShowErrorAlert(true);
            setTimeout(() => setShowErrorAlert(false), 3000);
        }
    };

    const inviteUser = async (user, moduleValue) => {
        try {
            const res = await sendBulkInvitations({
                variables: {
                    input: {
                        sendToAll: false,
                        email: user.email,
                        requestingUserEmail: userInfo?.getUser?.email,
                        organizationId: userInfo?.getUser?.iamTenant?.iamOrganizationId,
                        moduleName: moduleValue,
                        tenantId: userInfo?.getUser?.iamTenant?.tenantId,
                    },
                },
            });
            if (res.data?.sendBulkInvitations) {
                setSuccessMsg(`Invitation sent to ${user.email}!`);
                await refetchIntakeList();
                setShowSuccessAlert(true);
                setTimeout(() => setShowSuccessAlert(false), 3000);
            }
        } catch (err) {
            setErrorMsg(`Error sending invitation to ${user.email}!`);
            setShowErrorAlert(true);
            setTimeout(() => setShowErrorAlert(false), 3000);
        }
    };

    const handleModuleChange = (userId, newModule) => {
        setModuleMap(prev => ({ ...prev, [userId]: newModule }));
    };

    const columns = columnsConfig(inviteUser, handleModuleChange, moduleMap);

    /* Breadcrumb items configuration */
    const breadcrumbItems = [
        {
            link: '',
            value: (
                <span
                    className="appkiticon icon-home-fill font-16"
                    onClick={
                        () => {
                            showReportMenuVar(false);
                            history.push('/');
                            showCrossReportConfigVar(false);
                            leftNavigationItemsVar([]);
                            moduleIdVar(null);
                        }
                    }
                    role="presentation"
                />
            ),
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text">Registration Intake</span>,
        },
    ];

    /* Side effect when pending or invited status updates */
    useEffect(() => {
        // eslint-disable-next-line no-lonely-if
        if (active === false && inactive === false) {
            setTableData(registrationIntakeData?.getAllRegistrationIntake);
        } else if (active === true && inactive === false) {
            setTableData(registrationIntakeData?.getAllRegistrationIntake && registrationIntakeData?.getAllRegistrationIntake.filter(e => e.invitationStatus === 'PENDING'));
        } else if (active === false && inactive === true) {
            setTableData(registrationIntakeData?.getAllRegistrationIntake && registrationIntakeData?.getAllRegistrationIntake.filter(e => e.invitationStatus === 'INVITED'));
        } else {
            setTableData(registrationIntakeData?.getAllRegistrationIntake);
        }
    }, [active, inactive]);

    /* Side effect when filterString updates */
    useEffect(() => {
        const searchString = filterString.trim().toLowerCase();
        if (searchString.length > 0) {
            setTableData(
                registrationIntakeData?.getAllRegistrationIntake && registrationIntakeData?.getAllRegistrationIntake.filter(e => e.email.toLowerCase().match(searchString)),
            );
        } else {
            setTableData(registrationIntakeData?.getAllRegistrationIntake);
        }
    }, [filterString]);

    useEffect(() => {
        leftNavigationItemsVar(listItems);
        showCrossReportConfigVar(false);
        showDataReconMenusVar(false);
        showReportMenuVar(false);
        currentLeftMenuVar(ModuleEnum.INTAKE);
    }, []);

    useEffect(() => {
        if (registrationIntakeData?.getAllRegistrationIntake) {
            const processedData = registrationIntakeData.getAllRegistrationIntake.map(item => ({
                ...item,
                module: item?.module?.moduleName ?? 'Demo',
            }));
            setTableData(processedData);
        }
    }, [registrationIntakeData]);

    return (
        <Intake
            breadcrumbItems={breadcrumbItems}
            tableData={tableData}
            columns={columns}
            showSuccessAlert={showSuccessAlert}
            setShowSuccessAlert={setShowSuccessAlert}
            showErrorAlert={showErrorAlert}
            setShowErrorAlert={setShowErrorAlert}
            successMsg={successMsg}
            errorMsg={errorMsg}
            filterString={filterString}
            setFilterString={setFilterString}
            active={active}
            setActive={setActive}
            inactive={inactive}
            setInactive={setInactive}
        />
    );
}
